<template>
	<div>
		<div class="asd-margin" style="margin-top: 0px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/admin' }">智慧残联</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/admin/chizheng' }">持证数据管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div>
			<div style="display: flex;justify-content: space-between;margin-top: 10px;">
				<el-card style="width: 32%;">
					<div>
						<div style="font-size: 105%;margin-bottom: 10px;">持证残疾人数据</div>
					</div>
					<el-upload :on-error="cjerr" :on-success="cjsucc" :on-progress="cjpgress" ref="upload" :data="form" :auto-upload="false" style="width: 90%;" class="upload-demo"
						drag action="https://api.easyday-rdy.com/disable-api/task/importExcel" multiple>
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">只能上传xls,xlsx文件</div>
					</el-upload>
					<el-button @click="submitUpload" style="margin-top: 10px;" type="primary"
						size="small">上传</el-button>
				</el-card>
				<el-card style="width: 32%;">

				</el-card>
				<el-card style="width: 32%;">

				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					creator: "",
					organization: ""
				}
			}
		},
		computed:{
			info() {
				let info = window.localStorage.getItem("info");
				return JSON.parse(info);
			},
			org() {
				let org = window.localStorage.getItem("org");
				return JSON.parse(org);
			}
		},
		created() {
            this.form.creator=this.info.name;
			this.form.organization=this.org.name;
		},
		methods: {
			cjerr(res,f,fl){
				console.log(res);
				console.log(f);
				console.log(fl);
			},
			cjsucc(res,f,fl){
				console.log(res);
				console.log(f);
				console.log(fl);
			},
			cjpgress(eve,f,fl){
				console.log(eve);
				console.log(f);
				console.log(fl);
			},
			submitUpload() {
				this.$refs.upload.submit();
			}
		}
	}
</script>

<style>
</style>